var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCard',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"spinner-card"},[_c('div',{staticClass:"card-section"})])}
var staticRenderFns = []

export { render, staticRenderFns }